import {ACTIONS} from '../01-actions/adminImages';

const initialState = {
	images: [],
	imageAdd: null,
	imageRemove: null,
	imageEdit: null,
};

export default (state = initialState, action) => {
	switch (action.type) {
		case ACTIONS.IMAGE_LOAD_PROGRESS:
			return {
				...state,
				status: action.type,
			};
		case ACTIONS.IMAGE_LOAD_SUCCESS:
			return {
				...state,
				status: action.type,
				images: action.data.images,
			};
		case ACTIONS.IMAGE_LOAD_FAILED:
			return {
				...state,
				status: action.type,
				error: action.data.error
			};
		case ACTIONS.IMAGE_ADD_PROGRESS:
			return {
				...state,
				status: action.type,
				imageAdd: action.data,
			};
		case ACTIONS.IMAGE_ADD_SUCCESS:
			return {
				...state,
				status: action.type,
				images: [
					...state.images,
					Object.assign({}, state.imageAdd, action.data)
				]
			};
		case ACTIONS.IMAGE_ADD_FAILED:
			return {
				...state,
				status: action.type,
				error: action.data.error
			};
		case ACTIONS.IMAGE_REMOVE_PROGRESS:
			return {
				...state,
				status: action.type,
				imageRemove: action.data,
			};
		case ACTIONS.IMAGE_REMOVE_SUCCESS: {
			let index = state.images.findIndex(image => image.type === state.imageRemove.type && image.name === state.imageRemove.name);
			return {
				...state,
				status: action.type,
				images: [
					...state.images.slice(0, index),
					...state.images.slice(index + 1),
				]
			};
		}
		case ACTIONS.IMAGE_REMOVE_FAILED:
			return {
				...state,
				status: action.type,
				error: action.data.error
			};
		
		case ACTIONS.IMAGE_EDIT_PROGRESS:
			return {
				...state,
				status: action.type,
				imageEdit: action.data,
			};
		case ACTIONS.IMAGE_EDIT_SUCCESS: {
			let index = state.images.findIndex((image) =>
				image.type === state.imageEdit.type && image.name === state.imageEdit.name
			);
			return {
				...state,
				status: action.type,
				images: [
					...state.images.slice(0, index),
					Object.assign({}, state.images[index], state.imageEdit, action.data),
					...state.images.slice(index + 1),
				]
			};
		}
		case ACTIONS.IMAGE_EDIT_FAILED:
			return {
				...state,
				status: action.type,
				error: action.data.error
			};
		
		default:
			return state;
	}
}


// WEBPACK FOOTER //
// ./src/02-reducers/adminImages.js